import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AdminConfig } from '@features/referentiel/config/admin.config';
import { AppSourceEnum } from 'pu-core-library';

@Injectable({
  providedIn: 'root',
})
export class ParameterService {
  constructor(private httpClient: HttpClient) { }

  getParameters(): Observable<any> {
    return this.httpClient.get(
      `${AdminConfig.getParametersUrl}?source=${AppSourceEnum.POF}`,
    );
  }
}
